import { AppRoute } from 'app/app-layout/constants';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondary } from 'app/app-layout/models/nav/nav-item-secondary.model';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';

export class NotificationsNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: '$common_notifications',
      route: AppRoute.noOp,
      categoryId: NavCategoryId.NOTIFICATIONS,
      categoryIcon: 'ico-nav-notifications.svg',
      menuItems: [
        new NotificationsPlaceholderNavItem(),
      ],
    });
  }
}

export class NotificationsPlaceholderNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: 'Placeholder',
      route: AppRoute.noOp,
      scopes: [
        AppScopes.AUTOMATIC_EMAILS,
      ],
      categoryId: NavCategoryId.NOTIFICATIONS,
    });
  }
}
